import { DiscountDateErrors, PromotionalDiscount } from './types';

export function validateDiscount(discount: PromotionalDiscount): DiscountDateErrors {
  const errors: DiscountDateErrors = {};

  if (!discount.discount_name) {
    errors.discountName = 'Discount Name is required';
  }
  if (Number(discount.discount_percent) < 0 || Number(discount.discount_percent) > 100) {
    errors.discountPercent = 'Discount % must be between 0 and 100';
  }
  if (discount.is_room_type_scoped && !discount.room_type_ids?.length) {
    errors.roomTypeScope = 'Select at least one room for this promotion';
  }

  const schedule = discount.schedules?.[0];

  if (!schedule) {
    errors.activePeriodFrom = 'Active Period From is required';
    errors.activePeriodTo = 'Active Period To is required';
    errors.travelPeriodFrom = 'Travel Period From is required';
    errors.travelPeriodTo = 'Travel Period To is required';
    return errors;
  }

  if (!schedule.activePeriod.from) {
    errors.activePeriodFrom = 'Active Period From is required';
  }
  if (!schedule.activePeriod.to) {
    errors.activePeriodTo = 'Active Period To is required';
  }
  if (!schedule.travelPeriod.from) {
    errors.travelPeriodFrom = 'Travel Period From is required';
  }
  if (!schedule.travelPeriod.to) {
    errors.travelPeriodTo = 'Travel Period To is required';
  }
  return errors;
}

export function hasDiscountErrors(errors: DiscountDateErrors): boolean {
  return Object.values(errors).some(Boolean);
}
